export default {
  goTo: {
    en: '“{note}” note page',
  },
}
